import ResizeController from '../../../assets/js/controllers/resize';

// constants
import ProgressEvent from '../progress-event';

// helpers
import { validateParamBoolean } from '../../../assets/js/helpers';

export default class ProgressScrollBar {

	static selector = 'progress-scroll-bar';

	// class variables

	config = {
		autoIndex: true
	};

	controllers = {
		resize: null
	};

	el = {};

	flags = {
		isCursorEnabled: true
	};

	selectors = {
		autoIndex: '[data-auto-index]'
	};

	states = {
		index: 0,
		total: 0,
		handleWidth: 0,
		handleX: 0,
		scrollRatio: 0,
		trackWidth: 0
	};

	// constructor

	constructor(container) {
		this.el = {
			container,

			index: container.querySelector(`.${this.constructor.selector}__meta-index`),
			total: container.querySelector(`.${this.constructor.selector}__meta-total`),

			meta: container.querySelector(`.${this.constructor.selector}__meta`),
			metaInner: container.querySelector(`.${this.constructor.selector}__meta > span`),
			progress: container.querySelector(`.${this.constructor.selector}__progress`),
			track: container.querySelector(`.${this.constructor.selector}__track`),
		};

		this.states.total = parseInt(this.el.total.innerText);

		this.config.autoIndex = validateParamBoolean(this.el.container, this.selectors.autoIndex);

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		// listen for changes in the slider
		this.el.container.addEventListener(ProgressEvent.ADJUST, this.#onAdjust);
		this.el.container.addEventListener(ProgressEvent.CHANGE_INDEX, this.#onChangeIndex);

		// controller listeners

		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});

		this.measureResize();
		this.adjustResize();
	}

	#removeEventListeners = () => {
		this.el.container.removeEventListener(ProgressEvent.ADJUST, this.#onAdjust);
		this.el.container.removeEventListener(ProgressEvent.CHANGE_INDEX, this.#onChangeIndex);
	}

	// listener methods

	#onAdjust = (e) => {
		const ratio = Math.min(1, parseFloat(e.detail.ratio));
		if (!isNaN(ratio)) {
			this.states.scrollRatio = ratio;
			this.measureScroll();
			this.adjustScroll();
		}
	}

	#onChangeIndex = (e) => {
		const { index } = e.detail;
		this.states.index = index;
		this.adjustScroll();
	}

	// controller methods

	#onResizeUpdate = () => {
		this.measureResize();
		return true;
	}

	#onResizeRender = () => {
		this.adjustResize();
	}

	//

	measureScroll() {
		// slide track handle
		this.states.handleX = (this.states.handleWidth / 2) + this.states.scrollRatio * (this.states.trackWidth - this.states.handleWidth) - (this.states.handleWidth / 2);

		if (this.config.autoIndex) {
			// update numerical index
			this.states.index = parseInt(this.states.scrollRatio * (this.states.total - 1)) + 1;
		}
	}

	adjustScroll() {
		// slide track handle
		this.el.progress.style.transform = `translateX(${this.states.handleX}px)`;
		this.el.meta.style.transform = `translateX(${this.states.handleX}px)`;

		// update numerical index
		const indexString = this.states.index < 10 ? `0${this.states.index}` : this.states.index;
		this.el.index.innerHTML = indexString;
	}

	//

	measureResize() {
		const handleRatio = 1 / this.states.total;
		this.states.trackWidth = this.el.track.offsetWidth;
		this.states.handleWidth = Math.max(Math.round(this.states.trackWidth * handleRatio), this.el.metaInner.offsetWidth);
		this.measureScroll();
	}

	adjustResize() {
		this.el.progress.style.width = `${this.states.handleWidth}px`;
		this.el.progress.style.transform = `translateX(${this.states.handleX}px)`;

		this.el.meta.style.width = `${this.states.handleWidth}px`;
		this.el.meta.style.transform = `translateX(${this.states.handleX}px)`;
	}

	//

	adjustWidth() {

	}

	adjustPosition() {

	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
